/* Ixaria PDP — real product data over the prototype's stand-ins
   ---------------------------------------------------------------------------
   The mobile PDP is a port of a Boston mockup, so several things it shows are
   Boston's rather than this product's: the shape strip lists four fixed shapes
   with fixed footprints and fixed artwork, and the hero's first slide is a
   stock render swapped between six Luna colours by filename.

   All of that is authored per product in the Ixaria app and arrives on
   window.IX_PDP.ixaria (see sections/ixaria-mobile-pdp.liquid):

     shapes.order / shapes.byId   per shape: thumbnailUrl, dimensions,
                                  sleepingArea, storageVolume
     nameIndex.shapeNames         shape name -> option value gid
     materials.byId               material type gid -> { colorIds }
     shapeGallery                 { _cdn, byShapeId: { gid: [path, ...] } }
     comboPreviews                { _cdn, byShapeId: { gid | "_default":
                                    { materialGid: { colorId: [path, ...] } } } }

   Everything here is a replacement, never a requirement: whatever the app has
   not published for a product stays exactly as the section rendered it. A
   product with no Ixaria config at all is untouched. */

(function () {
  var DATA = (window.IX_PDP && window.IX_PDP.ixaria) || {};

  /* Relative paths are stored without their CDN prefix so the metafield stays
     small; _cdn carries it. */
  function resolve(bundle, path) {
    if (!path) return null;
    if (/^https?:\/\//i.test(path)) return path;
    var cdn = (bundle && bundle._cdn) || "";
    return cdn + path;
  }

  /* ── Shapes ─────────────────────────────────────────────────────────
     The order the admin put them in, paired with the name Shopify knows each
     by — that name is what the rest of the page, and the configurator handoff,
     match on. */
  function shapeList() {
    var shapes = DATA.shapes || {};
    var byId = shapes.byId || {};
    var names = (DATA.nameIndex && DATA.nameIndex.shapeNames) || {};

    var nameByGid = {};
    Object.keys(names).forEach(function (name) {
      nameByGid[names[name]] = name;
    });

    var order = shapes.order && shapes.order.length ? shapes.order : Object.keys(byId);
    var out = [];
    order.forEach(function (gid) {
      var shape = byId[gid];
      var name = nameByGid[gid];
      /* No name means nothing can select it; no shape means the index is
         pointing at something that is not configured. Either way, skip. */
      if (!shape || !name) return;
      out.push({ gid: gid, name: name, shape: shape });
    });
    return out;
  }

  /* "295 x 190 cm", from the footprint the admin holds for the shape. Height is
     not part of what this strip shows. */
  function dimLabel(shape) {
    var d = shape && shape.dimensions;
    if (!d || !d.width || !d.depth) return null;
    return Math.round(d.width) + " x " + Math.round(d.depth) + " cm";
  }

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }

  /* ── The shape strip ────────────────────────────────────────────────
     Rebuilt rather than patched: the number of shapes is per product, and the
     ported markup happens to carry four. Products with no shapes configured
     keep the markup as shipped — better a stand-in than an empty sheet. */
  function renderShapes() {
    var list = shapeList();
    /* Scoped to the PDP's own sheet on purpose: when the configurator overlay
       is injected into this page it brings its own hidden element with the
       same id, and getElementById would hand back whichever parsed first. */
    var grid = document.querySelector("#view-shape .shape-grid");
    if (!grid || !list.length) return null;

    /* Forma de pornire: prima din aplicatie, afara de cazul in care clientul
       vine dintr-o colectie care cere alta (DATA.startShape, din PLP-ul de
       colțare: colțarul cel mai ieftin — snippets/ixaria-context-shape.liquid). */
    var start = 0;
    if (DATA.startShape) {
      var norm = function (s) {
        return String(s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();
      };
      var want = norm(DATA.startShape);
      for (var k = 0; k < list.length; k++) {
        if (norm(list[k].name) === want) { start = k; break; }
      }
    }

    var missingArt = 0;
    var html = list
      .map(function (entry, i) {
        var dim = dimLabel(entry.shape);
        var art = entry.shape.thumbnailUrl;
        if (!art) missingArt++;
        /* Keep the tile's own artwork when the admin has not uploaded one, so
           a shape without a thumbnail still reads as a shape. */
        var fallback = grid.querySelectorAll(".stile img")[i];
        var src = art || (fallback && fallback.getAttribute("src")) || "";
        return (
          '<button class="stile' +
          (i === start ? " on" : "") +
          '" data-name="' +
          esc(entry.name) +
          '" data-dim="' +
          esc(dim || "") +
          '" data-shape-gid="' +
          esc(entry.gid) +
          '" onclick="pickShape(this)">' +
          '<span class="simg"><img src="' +
          esc(src) +
          '" alt="' +
          esc(entry.name) +
          '" loading="lazy"></span>' +
          '<span class="stx"><span class="sn">' +
          esc(entry.name) +
          "</span>" +
          (dim ? '<span class="sd">' + esc(dim) + "</span>" : "") +
          "</span></button>"
        );
      })
      .join("");

    grid.innerHTML = html;
    /* poza din randul „Schimba" urmeaza forma aleasa (prima, la incarcare) */
    if (typeof window.syncTypeselImage === "function") window.syncTypeselImage();
    if (typeof window.ixUpdatePriceForShape === "function") window.ixUpdatePriceForShape(list[start].name);

    /* The buy-box summary shows whichever shape is selected, so start it on
       the same one the strip marks. */
    var first = list[start];
    var nameEl = document.querySelector("#typesel .t-n");
    var dimEl = document.querySelector("#typesel .t-d");
    if (nameEl) nameEl.textContent = first.name;
    if (dimEl) {
      var d = dimLabel(first.shape);
      if (d) dimEl.textContent = d;
    }

    console.info(
      "[ixaria] PDP shapes from the app — " +
        list
          .map(function (e) {
            return e.name + " (" + (dimLabel(e.shape) || "no dimensions") + ")";
          })
          .join(" | ") +
        (missingArt ? " — " + missingArt + " without a thumbnail" : ""),
    );
    return list;
  }

  /* ── Preview photography ────────────────────────────────────────────
     Two sources, most specific first. A combination preview is a photo of this
     shape in this colour; a shape gallery image is a photo of this shape in
     whatever colour it was shot. Below both sits whatever the section already
     put in the slide. */
  var NO_SHAPE_KEY = "_default";
  /* True while the page itself re-selects a swatch (colours arriving from the API). */
  var autoPick = false;

  function gidForShapeName(name) {
    var names = (DATA.nameIndex && DATA.nameIndex.shapeNames) || {};
    return names[name] || null;
  }

  /* Datele formei (dimensiuni, suprafata de dormit). Produsul fara silueta nu
     numeste nicio forma: dimensiunile lui intregi stau in shapes._default. */
  function shapeData(shapeName) {
    var shapes = DATA.shapes || {};
    var gid = gidForShapeName(shapeName);
    if (gid) return (shapes.byId && shapes.byId[gid]) || null;
    return shapeList().length ? null : shapes[NO_SHAPE_KEY] || null;
  }

  /* „295 x 190 cm" pentru forma data (sau produsul intreg, fara silueta): linia din
     cos adaugata din pagina (ixaria-pdp.js, addToCart), la fel ca din configurator. */
  window.ixShapeDims = function (shapeName) {
    return dimLabel(shapeData(shapeName));
  };

  /* Figaro's material id for a swatch, via the plates the bridge publishes.
     Absent until the configurator bundle has booted, which is deliberate — it
     loads on idle — so callers fall back rather than wait. */
  function colorIdFor(colorName) {
    var plates = window.IXARIA_MATERIALS || {};
    var hit = plates[colorName];
    return (hit && hit.id) || null;
  }

  /* Which material type a colour belongs to; the previews are nested under it. */
  function materialGidFor(colorId) {
    var byId = (DATA.materials && DATA.materials.byId) || {};
    var keys = Object.keys(byId);
    for (var i = 0; i < keys.length; i++) {
      var ids = byId[keys[i]] && byId[keys[i]].colorIds;
      if (ids && ids.indexOf(colorId) !== -1) return keys[i];
    }
    return null;
  }

  /* Every preview of that combination, not just the first — the live gallery shows them all.
     A single path is stored as a string, several as an array. */
  function comboPreviews(shapeName, colorName) {
    var bundle = DATA.comboPreviews;
    var byShape = bundle && bundle.byShapeId;
    if (!byShape) return [];
    var shapeGid = shapeName ? gidForShapeName(shapeName) : null;
    var forShape = byShape[shapeGid] || byShape[NO_SHAPE_KEY];
    if (!forShape) return [];
    var colorId = colorIdFor(colorName);
    if (!colorId) return [];
    var matGid = materialGidFor(colorId);
    var byColor = (matGid && forShape[matGid]) || null;
    if (!byColor) {
      var mats = Object.keys(forShape);
      for (var i = 0; i < mats.length && !byColor; i++) {
        if (forShape[mats[i]] && forShape[mats[i]][colorId]) byColor = forShape[mats[i]];
      }
    }
    var raw = byColor && byColor[colorId];
    var list = Array.isArray(raw) ? raw : raw ? [raw] : [];
    return list
      .map(function (path) {
        return resolve(bundle, path);
      })
      .filter(Boolean);
  }

  /* ── Randarile frontale ────────────────────────────────────────────
     Cele 6 culori din banda si prima culoare a fiecarui alt tip de material (cea
     aleasa la un click pe tip, stripForType), pe fiecare forma, gata facute cu
     motorul Ixaria (DATA.frontRenders, snippets/ixaria-front-renders.liquid):
     { forma: { culoare: url } }, cu numele ca handle („canapea-3-locuri",
     „luna-08"). Produsul fara forme are forma „default". Cand forma si culoarea
     alese au una, ea e prima poza din carusel — fara sa astepte motorul. */
  function nameSlug(s) {
    return String(s || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function frontShapeSet(shapeName) {
    var map = DATA.frontRenders;
    if (!map) return null;
    return map[shapeName ? nameSlug(shapeName) : NO_SHAPE_KEY.replace(/^_/, "")] || null;
  }

  function frontRender(shapeName, colorName) {
    var set = frontShapeSet(shapeName);
    return (set && colorName && set[nameSlug(colorName)]) || null;
  }

  /* Celelalte culori ale formei se descarca in fundal imediat ce prima poza a eroului
     s-a incarcat, ca un click pe banda sa arate poza pe loc. Inainte asteptau sfarsitul
     paginii (load), care pe telefon vine cu secunde bune dupa erou — motorul 3D, galeria,
     scripturile magazinului (masurat pe Natalie, 4G: eroul la 3,4 s, load la 8,1 s).
     Ordinea e a manifestului: cele 6 din banda, apoi prima culoare a fiecarui alt tip de
     material. Cu „economisire date" pornita in browser nu se descarca nimic in avans. */
  var frontPrefetched = {};
  var heroFirstLoaded = null;
  function afterFirstHeroImage(fn) {
    if (!heroFirstLoaded) {
      heroFirstLoaded = new Promise(function (resolve) {
        var trk = document.getElementById("herotrk");
        var img = trk && (trk.querySelector(".sl-ix[data-ix='front'] img") || trk.querySelector(".sl img"));
        if (!img || (img.complete && img.naturalWidth)) return resolve();
        img.addEventListener("load", resolve, { once: true });
        img.addEventListener("error", resolve, { once: true });
        /* eroul poate astepta poza facuta de motor (o culoare fara randare): nu la nesfarsit */
        setTimeout(resolve, 5000);
      });
    }
    heroFirstLoaded.then(fn);
  }

  function prefetchFrontRenders(shapeName) {
    var set = frontShapeSet(shapeName);
    if (!set) return;
    var conn = navigator.connection;
    if (conn && conn.saveData) return;
    afterFirstHeroImage(function () {
      /* pe desktop si miniatura din coloana #thumbs, pe care o arata noua selectie */
      var thumbs = document.getElementById("thumbs");
      var withThumb = !!(thumbs && thumbs.getClientRects().length);
      Object.keys(set).forEach(function (k) {
        var url = set[k];
        if (frontPrefetched[url]) return;
        frontPrefetched[url] = true;
        var img = new Image();
        img.decoding = "async";
        /* acelasi srcset ca in erou: browserul alege aceeasi marime, deci o gaseste in cache */
        if (window.ixSetImgSrc) window.ixSetImgSrc(img, url);
        else img.src = url;
        if (withThumb && window.ixThumbSrc) new Image().src = window.ixThumbSrc(url);
      });
    });
  }

  function shapeGallery(shapeName) {
    var bundle = DATA.shapeGallery;
    var byShape = bundle && bundle.byShapeId;
    if (!byShape) return [];
    var gid = shapeName ? gidForShapeName(shapeName) : null;
    var list = (gid && byShape[gid]) || byShape[NO_SHAPE_KEY];
    if (!list || !list.length) return [];
    return list
      .map(function (path) {
        return resolve(bundle, path);
      })
      .filter(Boolean);
  }

  function currentShapeName() {
    var tile = document.querySelector("#view-shape .shape-grid .stile.on");
    return tile ? tile.getAttribute("data-name") : null;
  }

  function currentColorName() {
    var sw = document.querySelector("#pdp .sw.on");
    return sw ? sw.getAttribute("data-name") : null;
  }



  /* ── Descrierea pe formă ────────────────────────────────────────────
     Când ixaria.tab_general_info este scris în mod "byShape", secțiunea
     Informații generale conține câte un bloc per formă, toate randate de
     Liquid și ascunse în afară de primul. Forma aleasă decide care se vede. */
  function showGeneralInfoFor(shapeName) {
    var host = document.getElementById("ix-gi-shapes");
    if (!host) return;
    var blocks = host.querySelectorAll(".ix-gi-shape");
    if (!blocks.length) return;
    var matched = false;
    blocks.forEach(function (b) {
      var hit = b.getAttribute("data-shape-name") === shapeName;
      b.hidden = !hit;
      if (hit) matched = true;
    });
    /* O formă fără text propriu nu lasă secțiunea goală: rămâne primul bloc. */
    if (!matched) blocks[0].hidden = false;
    syncShortDescription();
    applyVicDescriptionToSheet();
  }

  /* Panoul „Informatii generale" cere textul formei alese chiar inainte sa se
     deschida, ca sa nu arate forma de dinainte daca ceva a scapat nesincronizat
     (ixaria-pdp.js, openInfo). */
  window.ixSyncGeneralInfo = function () {
    showGeneralInfoFor(currentShapeName());
  };

  /* ── Descrierea din vic-app ─────────────────────────────────────────
     Fiecare formă este legată de o variantă Figaro, iar varianta are propriul
     câmp „Descriere", scris în vic-app (ProductVariant.description). Acela e
     textul cerut aici, și nu trece prin metafield-urile Shopify.

     Se citește din snapshot-ul produsului — același fișier pe care
     ixaria-figaro-preload.js îl aduce oricum în cache — în loc să pornim
     engine-ul 3D doar pentru o propoziție. Cheia din productVariantMap este
     chiar figaroVariantId din variant_config, deci legătura formă -> text se
     face fără nicio potrivire după nume. */
  var variantDescriptions = null; /* figaroVariantId -> descriere */

  function variantIdForShape(shapeName) {
    var gid = gidForShapeName(shapeName);
    var shape = gid && DATA.shapes && DATA.shapes.byId && DATA.shapes.byId[gid];
    return (shape && shape.figaroVariantId) || null;
  }

  function vicDescriptionFor(shapeName) {
    if (!variantDescriptions) return null;
    var id = variantIdForShape(shapeName);
    return (id && variantDescriptions[id]) || null;
  }

  /* Aceiasi tokeni ca snippets/ixaria-shape-text.liquid, cu datele formei alese.
     Un token fara valoare ramane cum e, la fel ca in Liquid. Fara forme din
     aplicatie, [[shape_name]] devine titlul produsului (ca in sectiune). */
  function fillShapeTokens(text, shapeName) {
    var shape = shapeData(shapeName);
    var title = (window.IX_PDP && window.IX_PDP.product && window.IX_PDP.product.title) || "";
    var d = (shape && shape.dimensions) || {};
    var sl = (shape && shape.sleepingArea) || {};
    var values = {
      shape_name: shapeName || title,
      shape_width: d.width,
      shape_height: d.height,
      shape_depth: d.depth,
      sleeping_width: sl.width,
      sleeping_depth: sl.depth,
      storage_volume: shape && shape.storageVolume,
      product_title: title,
    };
    return String(text).replace(/\[\[(\w+)\]\]/g, function (token, key) {
      var v = values[key];
      return v === undefined || v === null || v === "" ? token : String(v);
    });
  }

  /* Descrierea produsului din aplicatie (ixaria.product_description), completata
     pentru forma data. null cand produsul nu o are. */
  function appDescriptionFor(shapeName) {
    return DATA.productDescription ? fillShapeTokens(DATA.productDescription, shapeName) : null;
  }

  /* Adevarat de la inceput cand exista snapshot: adopt() sincronizeaza descrierea
     inainte sa porneasca cererea. */
  var snapshotPending = !!(
    window.IX_PDP && window.IX_PDP.figaro && window.IX_PDP.figaro.snapshotUrl &&
    typeof fetch === "function"
  );
  function snapshotDone() {
    restoreDefaultSwatches();
    if (!snapshotPending) return;
    snapshotPending = false;
    syncShortDescription();
  }

  /* Banda are acum placile ei definitive (din aplicatie sau cele din tema).
     ixaria-pdp.js aplica abia atunci culoarea din adresa (?culoare=): pusa mai
     devreme, ar fi fost stearsa de banda care se rescrie cand sosesc culorile. */
  function announceSwatches() {
    window.ixSwatchesReady = true;
    document.dispatchEvent(new CustomEvent("ixaria:swatches-ready"));
  }

  /* Scheletul benzii de culori ramane doar pana vin culorile din snapshot. Daca nu vin
     (cerere esuata, produs fara culori configurate), se pun inapoi placile din tema. */
  function restoreDefaultSwatches() {
    var strip = document.querySelector("#pdp .sw-strip.is-loading");
    var tpl = document.getElementById("sw-default-strip");
    if (!strip || !tpl) return;
    strip.innerHTML = tpl.innerHTML;
    strip.classList.remove("is-loading");
    strip.removeAttribute("aria-busy");
    var active = strip.querySelector(".sw.on") || strip.querySelector(".sw");
    if (active && typeof window.pickSwatch === "function") {
      autoPick = true;
      try {
        window.pickSwatch(active);
      } finally {
        autoPick = false;
      }
    }
    announceSwatches();
  }

  function loadSnapshot() {
    var url = window.IX_PDP && window.IX_PDP.figaro && window.IX_PDP.figaro.snapshotUrl;
    if (!url || typeof fetch !== "function") return snapshotDone();
    snapshotPending = true;
    /* plasa de siguranta: descrierea nu ramane goala daca cererea atarna */
    setTimeout(snapshotDone, 8000);
    fetch(url, { credentials: "omit", mode: "cors" })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (snap) {
        if (!snap) return snapshotDone();
        snapshotPending = false;
        adoptVariantDescriptions(snap);
        adoptMaterials(snap);
        syncShortDescription();
      })
      .catch(function () {
        /* fără snapshot rămâne textul de rezervă */
        snapshotDone();
      });
  }

  function adoptVariantDescriptions(snap) {
    var map = snap.productVariantMap;
    if (!map) return;
    var found = 0;
    variantDescriptions = {};
    Object.keys(map).forEach(function (id) {
      var d = map[id] && map[id].description;
      if (d && String(d).trim()) {
        variantDescriptions[id] = String(d).trim();
        found++;
      }
    });
    console.info(
      "[ixaria] descrieri din vic-app — " + found + " variantă(e) cu text",
    );
    if (!found) return;
    syncShortDescription();
    applyVicDescriptionToSheet();
  }

  /* ── Culorile ───────────────────────────────────────────────────────
     Banda de sub sofa avea şase materiale Luna scrise în markup, cu imagini
     din temă — aceleaşi pe orice produs. Ce oferă produsul chiar este scris în
     variant_config (materials.colorIds), iar numele şi placa fiecărei culori
     stau în acelaşi snapshot: originalMaterialMap[colorId].

     Cheile sunt identice, deci legătura se face fără potrivire după nume. */
  var MAX_SWATCHES = 6;
  /* Culorile pe care produsul chiar le ofera, ca banda sa poata fi refacuta
     fara sa se mai ceara o data lista din aplicatie. */
  var lastOffered = null;
  /* Toate materialele produsului din aplicatie (vic-app), din snapshot
     (originalMaterialMap): colorKey(nume) -> { id, name, url }. Lista din Shopify
     (variant_config.colorIds, „offered") are doar culorile cu poze facute ale
     canapelei; in aplicatie produsul are mai multe (Natalie: 4 Luna in Shopify,
     21 in aplicatie). Culorile populare se verifica pe lista asta. */
  var appColors = {};
  /* si sectiunea „Materiale" (ixaria-pdp-materials.js): toate nuantele produsului, cu placa
     lor, ca in configurator; evenimentul ixaria:product-colours anunta ca au sosit */
  window.ixProductColours = function () {
    return Object.keys(appColors).map(function (k) { return appColors[k]; });
  };

  function configuredColorIds() {
    var m = DATA.materials || {};
    if (m.colorIds && m.colorIds.length) return m.colorIds.slice();
    /* Configurări mai vechi ţin culorile doar sub fiecare tip de material. */
    var byId = m.byId || {};
    var order = m.order && m.order.length ? m.order : Object.keys(byId);
    var out = [],
      seen = {};
    order.forEach(function (gid) {
      ((byId[gid] && byId[gid].colorIds) || []).forEach(function (id) {
        if (!seen[id]) {
          seen[id] = true;
          out.push(id);
        }
      });
    });
    return out;
  }

  /* ── Textura materialului ales, ca ultima poza din galerie ──
     Placa din banda (presentation.thumbnail) are doar 200px. Materialul trimite insa
     si textura de culoare folosita pe modelul 3D — baseColor.map.sources.xId, cheie
     in snapshot.textureMap — la 1024px, destul pentru o poza intreaga. */
  var textureByName = {};

  function textureFor(name) {
    if (!name) return null;
    if (textureByName[name]) return textureByName[name];
    /* „Luna 8" din markup fata de „Luna 08" din catalog */
    var m = /^(.*?)\s+(\d{1,2})$/.exec(name);
    if (!m) return null;
    var n = parseInt(m[2], 10);
    return textureByName[m[1] + " " + (n < 10 ? "0" + n : n)] || textureByName[m[1] + " " + n] || null;
  }
  /* si pozele de sus ale panoului „Colecția …" (ixMatPhotos, ixaria-pdp.js) */
  window.ixTextureFor = textureFor;

  /* ── Textura unei placi multicolore ──
     Placa din banda (data-colors) are doua culori taiate pe diagonala sau trei+
     in benzi orizontale (.sw-multi). Slide-ul texturii le arata la fel, desenate
     intr-o poza (canvas), ca miniaturile si galeria pe tot ecranul sa o
     foloseasca la fel ca pe orice alta poza. Cu doua culori poza e patrata, deci
     diagonala e la 45° prin centru, si umple latimea eroului ca orice poza
     (object-fit: cover taie sus si jos pe desktop). Cu benzi, poza are
     proportia eroului de pe desktop (4:3): cover o taie doar pe laturi (pe
     telefon eroul e patrat), deci benzile raman egale — taiata sus si jos,
     banda din mijloc ar iesi mai inalta. Texturile vin de pe cdn.ixaria.ro,
     care permite desenarea lor (Access-Control-Allow-Origin). */
  var multiTextures = {}; /* cheie -> adresa blob:, sau null cat se deseneaza */

  function currentColorNames() {
    var sw = document.querySelector("#pdp .sw.on");
    if (!sw || !sw.dataset.colors) return null;
    try {
      var names = JSON.parse(sw.dataset.colors);
      return Array.isArray(names) && names.length > 1 ? names.slice(0, 3) : null;
    } catch (e) {
      return null;
    }
  }

  /* ── Textura ca poza: dale puse cap la cap, nu una intinsa ──
     Texturile din aplicatie sunt dale facute sa se repete pe canapea (wrapS
     Repeat) si au cel mult 1024px (familia Manila: 128px, culoare plina).
     Intinsa pe tot eroul (1920px pe retina), dala de 1024px iesea marita de
     aproape doua ori, deci moale. Poza se deseneaza acum pe o panza de TEX_PX
     din dale la marimea lor: 1024px raman 1:1 (clare, tesatura ceva mai
     marunta), una de TEX_PX sau mai mare (daca aplicatia primeste texturi mai
     mari) acopera singura poza, ca inainte, iar una foarte mica se mareste de
     doua ori. Slide-ul e ultimul din galerie, deci are timp sa se deseneze
     pana ajunge clientul la el. */
  var TEX_PX = 1920;
  function texturePattern(ctx, img, w) {
    var n = img.naturalWidth;
    var s = n >= w ? w / n : n < 256 ? 2 : 1;
    var tile = document.createElement("canvas");
    tile.width = Math.max(1, Math.round(img.naturalWidth * s));
    tile.height = Math.max(1, Math.round(img.naturalHeight * s));
    var tc = tile.getContext("2d");
    tc.imageSmoothingQuality = "high";
    tc.drawImage(img, 0, 0, tile.width, tile.height);
    return ctx.createPattern(tile, "repeat");
  }
  var texturePhotos = {}; /* adresa texturii -> blob:, null cat se deseneaza, false daca n-a mers */
  function texturePhoto(name) {
    var url = textureFor(name);
    if (!url) return null;
    if (texturePhotos[url]) return texturePhotos[url];
    /* nu s-a putut desena: textura asa cum e, ca inainte */
    if (texturePhotos[url] === false) return url;
    if (url in texturePhotos) return null;
    texturePhotos[url] = null;
    loadCorsImage(url)
      .then(function (img) {
        var c = document.createElement("canvas");
        c.width = c.height = TEX_PX;
        var ctx = c.getContext("2d");
        ctx.fillStyle = texturePattern(ctx, img, TEX_PX);
        ctx.fillRect(0, 0, TEX_PX, TEX_PX);
        return new Promise(function (resolve) {
          c.toBlob(resolve, "image/jpeg", 0.9);
        });
      })
      .then(function (blob) {
        if (!blob) throw new Error("canvas gol");
        texturePhotos[url] = URL.createObjectURL(blob);
      })
      .catch(function (err) {
        texturePhotos[url] = false;
        console.info("[ixaria] textura nu s-a putut desena —", name, err);
      })
      .then(function () {
        refreshPreview(false);
      });
    return null;
  }

  function loadCorsImage(url) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = function () {
        resolve(img);
      };
      img.onerror = reject;
      img.src = url;
    });
  }

  /* Adresa pozei daca e gata; altfel porneste desenul si reface galeria dupa. */
  function multiTextureFor(names) {
    var urls = names.map(textureFor);
    if (!urls.every(Boolean)) return null;
    var key = names.join("|");
    if (multiTextures[key]) return multiTextures[key];
    if (key in multiTextures) return null;
    multiTextures[key] = null;
    Promise.all(urls.map(loadCorsImage))
      .then(function (imgs) {
        var w = TEX_PX,
          h = imgs.length === 2 ? TEX_PX : Math.round((TEX_PX * 3) / 4);
        var c = document.createElement("canvas");
        c.width = w;
        c.height = h;
        var ctx = c.getContext("2d");
        /* fiecare textura acopera toata poza din dale repetate (texturePattern),
           ca slide-ul unei singure culori, apoi se taie pe zona ei */
        var cover = function (img) {
          ctx.fillStyle = texturePattern(ctx, img, w);
          ctx.fillRect(0, 0, w, h);
        };
        imgs.forEach(function (img, i) {
          ctx.save();
          ctx.beginPath();
          if (imgs.length === 2) {
            /* ca .sw-multi-2: prima culoare sus-stanga, a doua jos-dreapta */
            if (i === 0) {
              ctx.moveTo(0, 0);
              ctx.lineTo(w, 0);
              ctx.lineTo(0, h);
            } else {
              ctx.moveTo(w, 0);
              ctx.lineTo(w, h);
              ctx.lineTo(0, h);
            }
          } else {
            /* ca .sw-multi-3: benzi orizontale, de sus in jos */
            var y0 = Math.round((h * i) / imgs.length);
            var y1 = Math.round((h * (i + 1)) / imgs.length);
            ctx.rect(0, y0, w, y1 - y0);
          }
          ctx.closePath();
          ctx.clip();
          cover(img);
          ctx.restore();
        });
        return new Promise(function (resolve) {
          c.toBlob(resolve, "image/jpeg", 0.9);
        });
      })
      .then(function (blob) {
        if (!blob) throw new Error("canvas gol");
        multiTextures[key] = URL.createObjectURL(blob);
        refreshPreview(false);
      })
      .catch(function (err) {
        console.info("[ixaria] textura combinatiei nu s-a putut desena —", names.join(" / "), err);
      });
    return null;
  }

  function adoptTextures(snap) {
    var map = snap.originalMaterialMap || {};
    var tex = snap.textureMap || {};
    Object.keys(map).forEach(function (id) {
      var mat = map[id];
      var xId = mat && mat.baseColor && mat.baseColor.map && mat.baseColor.map.sources && mat.baseColor.map.sources.xId;
      var file = xId && tex[xId] && tex[xId].fileInfo;
      if (mat && mat.name && file && file.downloadUrl) textureByName[mat.name] = file.downloadUrl;
    });
  }

  /* Zonele de culoare ale produsului (IX_CFG.figaro.config.materialZones), fiecare cu
     culorile pe care le poate primi: optiunile regulii ei din snapshot. Asa
     ixaria-pdp.js pune o placa multicolora facuta pe alta canapea pe zonele produsului
     asta (ixZoneColours) inca inainte sa porneasca motorul, iar banda stie ce
     combinatii poate face produsul (orderedSwatches). Partile cu optiunile lor
     (picioare, cusaturi) nu primesc tesaturi. */
  var zoneRules = null;
  function adoptZoneRules(snap) {
    var cfg = window.IX_CFG && window.IX_CFG.figaro && window.IX_CFG.figaro.config;
    var zones = (cfg && cfg.materialZones) || [];
    var rules = snap.originalMaterialConfigurationRuleMap || {};
    var mats = snap.originalMaterialMap || {};
    if (!zones.length) return;
    zoneRules = zones.map(function (z) {
      var names = {};
      ((rules[z.ruleName] && rules[z.ruleName].optionIds) || []).forEach(function (id) {
        if (mats[id] && mats[id].name) names[mats[id].name] = true;
      });
      return { key: z.ruleName, label: z.label || z.ruleName, names: names };
    });
  }
  window.ixZoneRules = function () {
    return zoneRules;
  };

  /* Cate zone pot primi toate culorile `names`: o combinatie are nevoie de cel putin
     doua. null cand nu se stie (fara snapshot sau fara zone in aplicatie). */
  function zonesFor(names) {
    if (!zoneRules) return null;
    return zoneRules.filter(function (r) {
      return names.every(function (n) {
        return r.names[n];
      });
    }).length;
  }

  function adoptMaterials(snap) {
    var map = snap.originalMaterialMap;
    if (!map) return;
    adoptTextures(snap);
    adoptZoneRules(snap);

    /* Rezolvarea plăcilor pe nume foloseşte tot catalogul, nu doar culorile
       acestui produs: grila completă şi rândurile „văzute recent" cer imagini
       după nume. Bridge-ul scrie acelaşi obiect când porneşte engine-ul, deci
       aici se completează doar ce lipseşte. */
    var plates = window.IXARIA_MATERIALS || {};
    var added = 0;
    Object.keys(map).forEach(function (id) {
      var m = map[id];
      var url =
        m && m.presentation && m.presentation.thumbnail && m.presentation.thumbnail.downloadUrl;
      if (m && m.name && url && !plates[m.name]) {
        plates[m.name] = { id: id, url: url };
        added++;
      }
    });
    if (added) window.IXARIA_MATERIALS = plates;
    /* Hex-ul placilor din aplicatie (presentation.color): ordinea grilei de culori din
       configurator si filtrul de culoare (ixAdoptSwatchColors, ixaria-collections.js). */
    if (typeof window.ixAdoptSwatchColors === "function") window.ixAdoptSwatchColors(map);

    appColors = {};
    Object.keys(map).forEach(function (id) {
      var m = map[id];
      var url =
        m && m.presentation && m.presentation.thumbnail && m.presentation.thumbnail.downloadUrl;
      if (m && m.name && url) appColors[colorKey(m.name)] = { id: id, name: m.name, url: url };
    });

    var offered = configuredColorIds()
      .map(function (id) {
        var m = map[id];
        var url =
          m && m.presentation && m.presentation.thumbnail && m.presentation.thumbnail.downloadUrl;
        return m && m.name && url ? { id: id, name: m.name, url: url } : null;
      })
      .filter(Boolean);

    console.info(
      "[ixaria] culori din API — " +
        offered.length +
        " configurate pentru produs, " +
        Object.keys(plates).length +
        " în catalog",
    );
    if (offered.length) renderSwatchStrip(offered);
    else restoreDefaultSwatches();
    /* texturile tocmai au sosit: galeria primeste ultima poza */
    refreshPreview(false);
    /* culorile si texturile produsului sunt gata, iar banda si-a ales culoarea */
    document.dispatchEvent(new CustomEvent("ixaria:product-colours"));
  }

  /* Ordinea benzii: primele locuri (cel mult trei) sunt ultimele culori alese in
     configurator (cea mai noua prima), iar restul pana la sase vin din cele mai
     populare 6 (DATA.popular, vezi ixaria-pdp-bootstrap.liquid) — cu trei alegeri,
     primele trei populare; fara nicio alegere, toate sase. Culorile populare intra
     daca produsul le are in aplicatie (appColors), chiar fara poze facute; ce nu
     ajunge se umple cu culorile cu poze facute (offered), in ordinea lor.
     Alegerile din configurator intra oricum. */
  function comboLabel(colors) {
    var names = colors.map(function (c) { return c.name; });
    if (typeof window.ixMultiLabel === "function") return window.ixMultiLabel(names);
    return names.join(" / ");
  }

  /* „Ce nevoi de lifestyle ai?" (assets/ixaria-pdp-lifestyle.js): un raspuns cu
     colectiile lui de materiale (window.ixLifeMaterials — Kids: Piano, Spello;
     Pets: Zoya, Orion, Maya, din ghidul de materiale Agache) umple banda doar cu
     culori din ele, fara alegerile din configurator. Intai cele populare
     (DATA.popular) din acele colectii, apoi cate una din fiecare colectie pe
     rand, luate la distanta egala prin catalogul ei (dupa numar), ca banda sa
     arate toata gama, nu sase nuante vecine. Produsul fara nicio culoare din
     colectiile cerute pastreaza banda obisnuita. */
  function lifestyleSwatches(offered) {
    var want = window.ixLifeMaterials;
    if (!want || !want.length) return null;
    var cols = want.map(function (c) { return String(c).trim().toLowerCase(); });
    var colOf = function (name) {
      var m = /^(.*\S)\s+\d+$/.exec(String(name || "").trim());
      return (m ? m[1] : String(name || "")).toLowerCase();
    };
    var numOf = function (name) {
      var m = /(\d+)\s*$/.exec(String(name || ""));
      return m ? +m[1] : 0;
    };
    var byCol = {}, seen = {}, byKey = {};
    cols.forEach(function (c) { byCol[c] = []; });
    var add = function (m) {
      if (!m || !m.url || !byCol[colOf(m.name)]) return;
      var k = colorKey(m.name);
      if (seen[k]) return;
      seen[k] = true;
      byKey[k] = m;
      byCol[colOf(m.name)].push(m);
    };
    offered.forEach(add);
    Object.keys(appColors).forEach(function (k) { add(appColors[k]); });
    var active = cols.filter(function (c) { return byCol[c].length; });
    if (!active.length) return null;
    active.forEach(function (c) {
      byCol[c].sort(function (a, b) { return numOf(a.name) - numOf(b.name); });
    });

    var out = [], taken = {};
    var take = function (m) {
      var k = colorKey(m.name);
      if (taken[k] || out.length >= MAX_SWATCHES) return;
      taken[k] = true;
      out.push(m);
    };
    popularNames().forEach(function (n) {
      if (byKey[colorKey(n)]) take(byKey[colorKey(n)]);
    });
    /* Locurile ramase, impartite pe rand intre colectii (una mica, ca Orion,
       le lasa pe ale ei celorlalte). */
    var left = MAX_SWATCHES - out.length, slots = {}, total = 0, grew = true;
    var rest = {};
    active.forEach(function (c) {
      slots[c] = 0;
      rest[c] = byCol[c].filter(function (m) { return !taken[colorKey(m.name)]; });
    });
    while (total < left && grew) {
      grew = false;
      active.forEach(function (c) {
        if (total < left && slots[c] < rest[c].length) {
          slots[c]++;
          total++;
          grew = true;
        }
      });
    }
    var picks = {};
    active.forEach(function (c) {
      var list = rest[c], n = slots[c], step = n ? list.length / n : 0;
      picks[c] = [];
      for (var j = 0; j < n; j++) picks[c].push(list[Math.floor((j + 0.5) * step)]);
    });
    for (var r = 0; out.length < MAX_SWATCHES; r++) {
      var any = false;
      active.forEach(function (c) {
        if (picks[c][r]) {
          take(picks[c][r]);
          any = true;
        }
      });
      if (!any) break;
    }
    return out;
  }

  function orderedSwatches(offered) {
    var life = lifestyleSwatches(offered);
    if (life) return { list: life, recent: 0 };
    var byName = {};
    offered.forEach(function (m) { byName[m.name] = m; });
    var taken = {};
    var keyOf = function (entry) {
      return (entry.colors || [entry])
        .map(function (m) { return m.name; })
        .join("|");
    };
    /* Culorile alese in configurator ajung in banda chiar daca lista
       produsului nu le contine: clientul tocmai a configurat canapeaua in ele,
       iar placa se ia din catalogul aplicatiei. */
    var plateFor = function (name) {
      if (!name) return null;
      if (byName[name]) return byName[name];
      var plate = (window.IXARIA_MATERIALS || {})[name];
      if (plate && plate.url) {
        byName[name] = { id: plate.id, name: name, url: plate.url };
        return byName[name];
      }
      if (typeof window.fabricAsset === "function") {
        var url = window.fabricAsset(name);
        if (url) {
          byName[name] = { name: name, url: url };
          return byName[name];
        }
      }
      return null;
    };
    /* O intrare este fie un material, fie o combinatie de doua-trei culori —
       asa cum a fost aleasa pe zone in configurator. */
    /* Colectia unei culori, din nume: „Luna" din „Luna 16". */
    var collectionOf = function (name) {
      var m = /^(.*\S)\s+\d+$/.exec(String(name || "").trim());
      return (m ? m[1] : String(name || "")).toLowerCase();
    };
    var entryFor = function (names) {
      var colors = [];
      for (var i = 0; i < names.length; i++) {
        var hit = plateFor(String(names[i] || "").trim());
        if (!hit) return null;
        if (colors.indexOf(hit) === -1) colors.push(hit);
      }
      if (!colors.length) return null;
      if (colors.length === 1) return colors[0];
      /* O combinatie din doua colectii nu mai intra in banda: in configurator toate
         zonele sunt din aceeasi colectie (pickFabricSwatch), deci aleasa din banda nu
         putea primi nici poza configuratiei, nici configuratia insasi. Poate ramane in
         vizita de dinainte de regula asta (sessionStorage). */
      var cols = [];
      colors.forEach(function (c) {
        var k = collectionOf(c.name);
        if (cols.indexOf(k) === -1) cols.push(k);
      });
      if (cols.length > 1) return null;
      colors = colors.slice(0, 3);
      /* Nici pe o canapea cu o singura zona de tesatura (Leni, Remo, Ramon): acolo
         configuratorul nu are Multicolor, deci nici combinatia nu se poate face. */
      var fit = zonesFor(colors.map(function (c) { return c.name; }));
      if (fit !== null && fit < 2) return null;
      return { colors: colors, name: comboLabel(colors) };
    };
    var push = function (out, entry, max) {
      if (!entry || out.length >= max) return;
      var k = keyOf(entry);
      if (taken[k]) return;
      taken[k] = true;
      out.push(entry);
    };

    /* Alegerile din configurator tin cat tine vizita (sessionStorage), nu mai mult:
       la o vizita noua banda porneste de la culorile produsului. */
    var recent = [];
    try {
      recent = JSON.parse(sessionStorage.getItem("ixaria:recentColors") || "[]");
      localStorage.removeItem("ixaria:recentColors");
    } catch (e) {}
    if (!Array.isArray(recent)) recent = [];
    var head = [];
    recent.forEach(function (e) {
      /* intrarile vechi tineau un singur nume, cele noi toata alegerea */
      push(head, entryFor(Array.isArray(e) ? e : [e]), 3);
    });
    /* „Luna 8" scris de mana si „Luna 08" din aplicatie sunt aceeasi culoare. */
    var offeredByKey = {};
    offered.forEach(function (m) { offeredByKey[colorKey(m.name)] = m; });
    var best = [];
    popularNames().forEach(function (n) {
      var k = colorKey(n);
      push(best, offeredByKey[k] || appColors[k] || null, MAX_SWATCHES - head.length);
    });
    /* Fara lista de populare (sau cu culori pe care produsul nu le are), locurile
       ramase sunt primele culori din aplicatie — chiar ordinea din "rest". */
    var rest = offered.filter(function (m) { return !taken[m.name]; });
    /* recent: cate placi din fata sunt alegeri din configurator */
    return { list: head.concat(best, rest), recent: head.length };
  }

  /* Numele celor mai populare culori, oricum ar fi fost scrise: lista (metafield
     „List of single line text") sau text separat prin virgula / rand nou. */
  function popularNames() {
    var raw = DATA.popular;
    var list = Array.isArray(raw) ? raw : String(raw || "").split(/[,\n]/);
    return list
      .map(function (n) { return String(n == null ? "" : n).trim(); })
      .filter(Boolean)
      .slice(0, MAX_SWATCHES);
  }

  function colorKey(name) {
    return String(name || "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, " ")
      .replace(/\s0+(\d)/g, " $1");
  }

  /* Placa din banda care e culoarea din adresa: culoare=luna-08, sau culorile unei
     placi multicolore, culoare=luna-01_luna-17 (ixWriteUrl, ixaria-pdp.js). „Luna 8"
     si „Luna 08" sunt aceeasi culoare. null cand adresa nu alege nicio culoare din banda. */
  function urlSwatch(shown) {
    var v = null;
    try {
      v = new URLSearchParams(location.search).get("culoare");
    } catch (e) {}
    if (!v) return null;
    var k = function (s) {
      return nameSlug(s).replace(/(^|-)0+(?=\d)/g, "$1");
    };
    var want = v.split("_").map(k).join("_");
    return (
      shown.filter(function (m) {
        return (m.colors || [m]).map(function (c) { return k(c.name); }).join("_") === want;
      })[0] || null
    );
  }

  function renderSwatchStrip(offered, opts) {
    var strip = document.querySelector("#pdp .sw-strip");
    if (!strip) return;
    lastOffered = offered;
    opts = opts || {};
    var ordered = orderedSwatches(offered);
    /* Cu „Alege materialul" in pagina, banda are doar culorile tipului ales. */
    var typed = stripForType(ordered, opts);
    var recentCount = typed ? typed.recent : ordered.recent;
    var shown = (typed ? typed.list : ordered.list).slice(0, MAX_SWATCHES);

    /* La intrare, cat ixaria-pdp.js inca n-a pus culoarea din adresa (?culoare=, si
       cea din linkul pastrat pentru produs): banda porneste direct pe ea, cand e printre
       placi. Altfel se alegea intai alta placa, iar randarea ei pornea degeaba spre erou
       inaintea celei bune (ixUrlRestore o alegea imediat dupa). */
    var fromUrl = !opts.selectFirst && !opts.reset && !window.ixUrlLive ? urlSwatch(shown) : null;
    /* La intoarcerea din configurator conteaza ce tocmai s-a ales: prima placa,
       fie ea si o combinatie. */
    var keep;
    if (fromUrl) {
      keep = fromUrl.name;
    } else if (opts.selectFirst) {
      keep = shown[0].name;
    } else {
      /* Culoarea aleasă rămâne aleasă dacă produsul chiar o oferă — nu și la un alt
         răspuns „lifestyle" (opts.reset): banda lui poate avea alte culori, deci
         alegerea pornește de la capăt, ca la intrarea pe pagină. */
      var current = opts.reset ? null : currentColorName();
      var hasCurrent = shown.some(function (m) {
        return m.name === current;
      });
      /* Daca nu, prima culoare implicita a benzii, cea de dupa alegerile din
         configurator (cerut 2026-10-07): alegerile facute pe alt produs raman in banda,
         dar nu se aleg singure la intrare — poza lor o facea motorul, deci clientul
         astepta cateva secunde, iar cele implicite au randarea gata. */
      var first = shown[recentCount] || shown.filter(function (m) { return !m.colors; })[0] || shown[0];
      keep = hasCurrent ? current : first.name;
    }

    strip.classList.remove("is-loading");
    strip.removeAttribute("aria-busy");
    strip.innerHTML = shown
      .map(function (m, i) {
        /* data-recent: alegere din configurator, poate de pe alt produs. Nu se alege
           singura la incarcare (doar cand banda n-are nicio culoare implicita); aleasa
           atunci, intra si in adresa (ixUrlRestore, ixaria-pdp.js). */
        var recent = i < recentCount ? " data-recent" : "";
        if (m.colors) {
          /* Placa taiata: doua culori pe diagonala, trei+ in benzi orizontale (CSS .sw-multi). */
          var bands = m.colors
            .map(function (c) {
              return (
                '<span class="mc" style="background-image:url(\'' +
                esc(String(c.url).replace(/'/g, "%27")) +
                '\')"></span>'
              );
            })
            .join("");
          return (
            '<button class="sw sw-multi sw-multi-' +
            m.colors.length +
            (m.name === keep ? " on" : "") +
            '" data-name="' +
            esc(m.name) +
            '" data-colors="' +
            esc(JSON.stringify(m.colors.map(function (c) { return c.name; }))) +
            '"' +
            recent +
            ' aria-label="' +
            esc(m.name) +
            '" onclick="pickSwatch(this)">' +
            bands +
            "</button>"
          );
        }
        return (
          '<button class="sw' +
          (m.name === keep ? " on" : "") +
          '" data-name="' +
          esc(m.name) +
          '"' +
          recent +
          ' onclick="pickSwatch(this)"><img src="' +
          esc(m.url) +
          '" alt="' +
          esc(m.name) +
          '" decoding="async"></button>'
        );
      })
      .join("");

    /* pickSwatch scrie numele în cele trei locuri care îl afişează şi mută
       previzualizarea; lăsăm pagina să facă asta singură. */
    var active = strip.querySelector(".sw.on");
    if (active && typeof window.pickSwatch === "function") {
      /* Alegerea vine din pagina, nu de la client: caruselul nu sare. Cand
         alegerea e chiar a clientului (tocmai a inchis configuratorul),
         galeria se muta pe pozele combinatiei, ca la un click pe placa. */
      autoPick = !opts.userPick;
      try {
        window.pickSwatch(active);
      } finally {
        autoPick = false;
      }
    }
    announceSwatches();
    warmTierStrips();
    warmFronts();
  }

  /* Placile benzii fiecarui tip de material („Alege materialul"), cerute din timp, cat
     pagina sta: un click pe Practic / Confort / … reface banda (stripForType) cu poze noi
     de pe CDN-ul aplicatiei, iar inainte de asta fiecare tip astepta cele sase poze ale lui
     (~0,5s pe o conexiune buna, 2–3s pe una lenta; cerut 2026-10-19). Configuratorul le
     incarca si el, dar abia dupa ~10s, cand porneste pe fundal. Fiecare adresa o singura
     data; banda se reface de mai multe ori (intai din tema, apoi din aplicatie). */
  var warmed = {};
  var warmKeep = [];
  var warmTimer = 0;
  function warmTierStrips() {
    if (warmTimer || !lastOffered || !materialTiles().length) return;
    var run = function () {
      warmTimer = 0;
      var ordered = orderedSwatches(lastOffered);
      materialTiles().forEach(function (t) {
        if (!t.dataset.tier) return;
        var typed = stripForType(ordered, { tier: t.dataset.tier });
        if (!typed) return;
        typed.list.slice(0, MAX_SWATCHES).forEach(function (m) {
          (m.colors || [m]).forEach(function (c) {
            var u = c && c.url;
            if (!u || warmed[u]) return;
            warmed[u] = true;
            var im = new Image();
            im.decoding = "async";
            im.src = u;
            warmKeep.push(im);
          });
        });
      });
    };
    warmTimer = window.requestIdleCallback
      ? window.requestIdleCallback(run, { timeout: 1500 })
      : setTimeout(run, 600);
  }

  /* Randarile (poza mare) culorilor din benzi, pe forma aleasa (window.ixWarmFronts in
     ixaria-pdp.js; cerut 2026-10-20: la click poza apare pe loc). Intai banda de pe ecran, dupa
     incarcarea paginii, ca sa nu intarzie poza de sus; apoi, cand pagina sta, benzile celorlalte
     tipuri. La trecerea peste un tip (mouse, deget, tastatura), banda lui imediat. La alta forma
     (pickShape) iar, pentru randarile ei. */
  function tierNames(tier) {
    if (!lastOffered) return [];
    var typed = stripForType(orderedSwatches(lastOffered), { tier: tier });
    if (!typed) return [];
    return typed.list
      .slice(0, MAX_SWATCHES)
      .filter(function (m) {
        return !m.colors;
      })
      .map(function (m) {
        return m.name;
      });
  }
  var frontsTimer = 0;
  function warmFronts() {
    if (typeof window.ixWarmFronts !== "function") return;
    var go = function () {
      var visible = [].map.call(document.querySelectorAll("#pdp .sw-strip .sw[data-name]:not(.sw-multi)"), function (s) {
        return s.dataset.name;
      });
      window.ixWarmFronts(visible);
      if (frontsTimer || !materialTiles().length) return;
      var rest = function () {
        frontsTimer = 0;
        /* intai culoarea aleasa pe celelalte forme (o schimbare de forma), apoi benzile */
        if (typeof window.ixWarmOtherShapes === "function") window.ixWarmOtherShapes();
        materialTiles().forEach(function (t) {
          if (t.dataset.tier) window.ixWarmFronts(tierNames(t.dataset.tier));
        });
      };
      frontsTimer = window.requestIdleCallback
        ? window.requestIdleCallback(rest, { timeout: 3000 })
        : setTimeout(rest, 1500);
    };
    if (document.readyState === "complete") go();
    else window.addEventListener("load", go, { once: true });
  }
  window.ixWarmStripFronts = warmFronts;
  var warmTierOn = function (e) {
    var t = e.target && e.target.closest && e.target.closest("#mtsel .mt");
    if (t && t.dataset.tier && typeof window.ixWarmFronts === "function") window.ixWarmFronts(tierNames(t.dataset.tier));
  };
  document.addEventListener("pointerover", warmTierOn, { passive: true });
  document.addEventListener("touchstart", warmTierOn, { passive: true });
  document.addEventListener("focusin", warmTierOn);

  /* Banda se reface din „ixaria:recentColors" (sessionStorage): primele trei
     locuri sunt ultimele trei alegeri din configurator, cea mai noua prima.
     Chemata la inchiderea configuratorului (ixaria-figaro-bridge.js). */
  function refreshSwatchStrip(opts) {
    if (!lastOffered || !lastOffered.length) return false;
    renderSwatchStrip(lastOffered, opts);
    return true;
  }
  window.ixRefreshSwatchStrip = refreshSwatchStrip;

  /* Foaia „Informații generale" păstrează textul din Shopify când există
     (aplicația Ixaria sau Description) — are formatare și imagine. Descrierea
     din vic-app intră doar când Shopify nu are nimic; atunci și rândul care
     deschide foaia, ascuns până acum (ixaria-pdp-info), se arată. */
  function applyVicDescriptionToSheet() {
    if (document.getElementById("ix-gi-shapes")) return;
    var sec = document.getElementById("info-generale");
    if (!sec || sec.querySelector(".ix-tab-content")) return;
    var text = vicDescriptionFor(currentShapeName());
    if (!text) return;
    var holder = sec.querySelector(".ix-vic-desc");
    if (!holder) {
      holder = document.createElement("div");
      holder.className = "ix-tab-text ix-vic-desc";
      sec.appendChild(holder);
    }
    holder.textContent = text;
    var row = document.querySelector('#deep .drow[data-info="generale"]');
    if (row) row.hidden = false;
  }

  /* Teaserul de sub titlu și titlul din secțiunea „descoperă" spun același
     lucru, doar mai scurt. Sursa, în ordine: metafield-ul
     ixaria_product_description, cu forma aleasă în locul lui [[shape_name]];
     câmpul Description din Shopify; descrierea variantei din vic-app; la urmă
     „Informații generale" — blocul deja randat de Liquid, cu tokenii
     completați — ca să nu existe o a doua copie care să iasă din sincron. */
  function syncShortDescription() {
    var shapeName = currentShapeName();
    var text =
      appDescriptionFor(shapeName) ||
      DATA.shopifyDescription ||
      vicDescriptionFor(shapeName);
    /* Cat timp snapshot-ul e pe drum nu se scrie rezerva: ar aparea si apoi
       s-ar schimba in textul real. */
    if (!text && snapshotPending) return;
    if (!text) {
      var visible = document.querySelector(
        "#ix-gi-shapes .ix-gi-shape:not([hidden]) .ix-tab-text",
      );
      text = visible && visible.textContent;
    }
    if (!text || !text.trim()) {
      /* Nici snapshot, nici „Informatii generale": textul de rezerva din Liquid. */
      var empty = document.querySelector("#ix-pdp .p-desc-t[data-fallback]");
      if (empty && !empty.textContent.trim()) {
        text = empty.getAttribute("data-fallback");
      }
      if (!text || !text.trim()) return;
    }
    var teaser = document.querySelector("#ix-pdp .p-desc");
    if (teaser) {
      /* Se scrie doar in .p-desc-t, nu peste tot .p-desc: acolo sta si
         „Vezi mai mult", iar textContent pe parinte l-ar sterge (de aceea
         varianta veche il scotea si il punea inapoi).

         Nu se mai taie la 120 de caractere — taierea o face CSS-ul, la doua
         randuri, deci textul intreg trebuie sa ajunga in pagina. */
      var body = teaser.querySelector(".p-desc-t");
      var clean = String(text).replace(/\s+/g, " ").trim();
      if (body) body.textContent = clean;
      else {
        var more = teaser.querySelector(".more");
        teaser.textContent = clean + " ";
        if (more) teaser.appendChild(more);
      }
      /* Textul s-a schimbat, deci se remasoara: ce incapea inainte poate sa nu
         mai incapa acum. */
      if (window.syncDescMore) window.syncDescMore();
    }
    var headline = document.querySelector("#ix-pdp .dd-headline");
    /* Textul de sub film se afiseaza intreg — are loc pentru mai multe randuri
       si nu are un „vezi mai mult" care sa continue o fraza taiata. */
    if (headline) {
      headline.textContent = String(text).replace(/\s+/g, " ").trim();
      /* gol si ascuns cand textul trebuia sa vina din vic-app (deep-dive) */
      headline.hidden = false;
    }
  }

  /* ── Caruselul ──────────────────────────────────────────────────────
     Doar pozele din aplicatie, cele care urmeaza forma aleasa:
       1. previzualizarile pentru forma + culoarea aleasa
       2. galeria formei alese
     plus desenul cu dimensiunile formei, pe locul patru, textura culorii si
     filmul, la capat. Media produsului din Shopify nu mai intra in carusel
     cand produsul are poze in aplicatie (ixaria-pdp-gallery.liquid) — decat la
     o forma fara galerie in aplicatie, unde ia locul galeriei (shopMedia): coperta
     sta doar ca slide de rezerva (.sl-preview), pus inapoi la o forma fara
     nicio poza. Produsele fara poze in aplicatie isi pastreaza media (.sl-media).

     Previzualizarile colorate sosesc abia cand porneste configuratorul (pe
     fundal) si intra in fata listei. Ca poza de pe ecran sa nu se schimbe
     atunci sub ochii clientului, la o reconstructie care nu vine din alegerea
     lui poza de pe ecran ramane pe locul ei din lista si celelalte se aseaza
     in jurul ei. Dupa o alegere a clientului ordinea e cea de mai sus si
     caruselul sare la prima poza a alegerii. */
  var previewSlide = null;

  function makeSlide(url, kind) {
    var sl = document.createElement("div");
    sl.className = "sl sl-ix";
    sl.setAttribute("data-ix", kind);
    /* randarile frontale: srcset si miniatura mica (ixSetImgSrc / ixThumbSrc, ixaria-pdp.js) */
    sl.setAttribute("data-thumb", window.ixThumbSrc ? window.ixThumbSrc(url) : url);
    var img = document.createElement("img");
    if (window.ixSetImgSrc) window.ixSetImgSrc(img, url);
    else img.src = url;
    img.alt = (window.IX_PDP && window.IX_PDP.product && window.IX_PDP.product.title) || "";
    img.loading = "lazy";
    sl.appendChild(img);
    return sl;
  }

  /* jumpToIt: doar cand clientul a ales o forma sau o culoare. Atunci caruselul
     merge la prima imagine a alegerii (ca navigateToSetB de pe live). La
     incarcare si cand culorile sosesc din API nu se misca nimic. */
  /* Filmul din sectiunea „Descopera" (#vidsec): acelasi fisier, deci urmeaza si el
     forma aleasa (syncSectionVideo). */
  function sectionVideo() {
    var v = document.querySelector("#ix-pdp #vidsec video");
    if (!v) return null;
    var src = v.getAttribute("src");
    /* Fara posterul sectiunii: ix-video-poster.webp e o captura neclara cu
       „Descopera ..." scris pe ea. In galerie se vede primul cadru din film. */
    return src ? { src: src } : null;
  }

  /* Desenul cu dimensiunile formei alese: poza din „Informatii generale"
     (tab_general_info.byShape, randata de Liquid in #ix-gi-shapes). Doar a
     formei alese — desenul altei forme ar arata alte masuri —, deci o forma
     fara poza proprie nu are slide. */
  function dimensionsImage(shape) {
    var host = document.getElementById("ix-gi-shapes");
    if (!host || !shape) return null;
    var blocks = host.querySelectorAll(".ix-gi-shape");
    for (var i = 0; i < blocks.length; i++) {
      if (blocks[i].getAttribute("data-shape-name") !== shape) continue;
      var img = blocks[i].querySelector("img.ix-tab-image");
      return (img && img.getAttribute("src")) || null;
    }
    return null;
  }

  function makeVideoSlide(video) {
    var sl = document.createElement("div");
    sl.className = "sl sl-ix sl-video";
    sl.setAttribute("data-ix", "video");
    sl.setAttribute("data-video", video.src);
    var v = document.createElement("video");
    v.muted = true;
    v.loop = true;
    v.autoplay = true;
    v.playsInline = true;
    v.setAttribute("muted", "");
    v.setAttribute("autoplay", "");
    v.setAttribute("playsinline", "");
    /* metadata: se incarca primul cadru (in locul posterului), nu tot filmul */
    v.preload = "metadata";
    /* autoplay porneste filmul si cand slide-ul nu e pe ecran; atunci se opreste
       singur, iar heroRender il porneste cand ajunge slide-ul vizibil. */
    v.addEventListener("play", function () {
      if (!sl.classList.contains("is-active")) v.pause();
    });
    v.src = video.src;
    sl.appendChild(v);
    return sl;
  }

  /* Media produsului din Shopify (snippets/ixaria-pdp-gallery.liquid, #ix-shop-media): pozele de
     lifestyle si filmele produsului. Intra in carusel in locul galeriei formei, cand forma aleasa
     n-are galerie in aplicatie — produsele fara forme, ca Canapea Leni (cerut 2026-10-20: inainte
     caruselul avea doar randarea si pozele simple). Adresa fara &width=, ca ixSetImgSrc sa-i
     puna srcset-ul (latimea potrivita ecranului). */
  var shopMediaList = null;
  function shopMedia() {
    if (shopMediaList) return shopMediaList;
    shopMediaList = [];
    var el = document.getElementById("ix-shop-media");
    try {
      shopMediaList = (el && JSON.parse(el.textContent)) || [];
    } catch (e) {}
    shopMediaList.forEach(function (m) {
      if (m.src) m.src = String(m.src).replace(/([?&])width=\d+(&|$)/, function (x, a, b) { return b ? a : ""; });
    });
    return shopMediaList;
  }

  function refreshPreview(jumpToIt) {
    var trk = document.getElementById("herotrk");
    if (!trk) return;
    previewSlide = previewSlide || trk.querySelector(".sl-preview");

    var shape = currentShapeName();
    var combos = comboPreviews(shape, currentColorName());
    var gallery = shapeGallery(shape);
    var shop = gallery.length ? [] : shopMedia();
    var multi = currentColorNames();
    var texture = multi ? multiTextureFor(multi) : texturePhoto(currentColorName());
    var video = sectionVideo();
    var dims = dimensionsImage(shape);
    /* randarea frontala a formei si culorii alese, prima (nu si la o placa pe zone) */
    var front = multi ? null : frontRender(shape, currentColorName());
    /* Pana sosesc culorile (banda inca schelet) ramane randarea pusa de Liquid:
       altfel s-ar vedea o clipa fotografia din galerie inaintea ei. */
    if (!front && !currentColorName()) {
      var liquidFront = trk.querySelector(".sl-ix[data-ix='front'] img");
      if (liquidFront) front = liquidFront.getAttribute("src");
    }
    prefetchFrontRenders(shape);

    var want = [front || "", "|"]
      .concat(combos, ["|"], gallery, ["|"], shop.map(function (m) { return m.src || m.video; }), ["|", texture || "", "|", video ? video.src : "", "|", dims || ""])
      .join("\n");
    if (trk.getAttribute("data-ix-set") !== want) {
      trk.setAttribute("data-ix-set", want);
      /* la prima trecere slide-ul randat de Liquid nu are inca .is-active */
      var cur =
        trk.querySelector(".sl.is-active") ||
        trk.children[typeof window.heroIdx === "number" ? window.heroIdx : 0];
      var shown = cur && cur.querySelector("img");
      var keepSrc = !jumpToIt && shown ? shown.getAttribute("src") : null;
      var keepAt = cur ? Array.prototype.indexOf.call(trk.children, cur) : -1;
      /* Slide-ul randarii ramane pe loc, iar randarea noua intra lin peste cea veche
         (ixFadeInto, ixaria-pdp.js), ca pozele facute in configurator. Fara randare
         noua pleaca; ce arata pana atunci il tine ixaria-pdp.js (ixPendCfgShot), daca
         poza noua se face cu motorul. */
      var oldFront = trk.querySelector(".sl-ix[data-ix='front']");
      var oldFrontImg = oldFront && oldFront.querySelector("img:not(.cfg-next)");
      /* si cand pe ecran e poza raspunsului „lifestyle" (.sl-life): randarea era poza
         canapelei de dinaintea alegerii, deci cu ea porneste poza noua a selectiei */
      var lifeOn = cur && cur.classList.contains("sl-life");
      trk.ixFrontWas = !front && oldFront && (cur === oldFront || lifeOn) && oldFrontImg ? oldFrontImg.getAttribute("src") : null;
      trk.querySelectorAll(".sl-ix").forEach(function (sl) {
        if (!(front && sl === oldFront)) sl.remove();
      });
      /* Pozele selectiei (randarea, combinatiile, galeria formei) stau primele — dupa
         poza din configurator si pozele raspunsului „lifestyle" —, deci si inaintea
         mediei produsului din Shopify (.sl-media) la un produs fara poze in aplicatie,
         ca o copie a unui produs. Textura si filmul raman la capat. */
      var leads = trk.querySelectorAll(".sl-life, .sl-cfgshot");
      var prev = leads.length ? leads[leads.length - 1] : null;
      var put = function (sl) {
        trk.insertBefore(sl, prev ? prev.nextSibling : trk.firstChild);
        prev = sl;
      };
      if (front) {
        var frontSlide = oldFront;
        if (frontSlide) {
          frontSlide.setAttribute("data-thumb", window.ixThumbSrc ? window.ixThumbSrc(front) : front);
          if (typeof window.ixFadeInto === "function") window.ixFadeInto(frontSlide, front);
          else frontSlide.querySelector("img").src = front;
        } else {
          frontSlide = makeSlide(front, "front");
          /* pe ecran de la inceput: fara lazy */
          frontSlide.querySelector("img").loading = "eager";
        }
        put(frontSlide);
      }
      combos.forEach(function (url) {
        put(makeSlide(url, "combo"));
      });
      gallery.forEach(function (url) {
        put(makeSlide(url, "shape"));
      });
      shop.forEach(function (m) {
        if (m.video) {
          var vs = makeVideoSlide({ src: m.video });
          /* nu e filmul sectiunii: nu-l trateaza nimic ca pe acela */
          vs.setAttribute("data-ix", "media-video");
          if (m.poster) vs.setAttribute("data-thumb", m.poster);
          put(vs);
          return;
        }
        var ms = makeSlide(m.src, "media");
        if (m.alt) ms.querySelector("img").alt = m.alt;
        put(ms);
      });
      /* Textura materialului ales, apoi — ultimul — filmul produsului. */
      if (texture) trk.appendChild(makeSlide(texture, "texture"));
      if (video) trk.appendChild(makeVideoSlide(video));
      var hasIx = (front ? 1 : 0) + combos.length + gallery.length + shop.length > 0;
      if (hasIx && previewSlide && previewSlide.parentNode) previewSlide.remove();
      else if (!hasIx && previewSlide && !previewSlide.parentNode) {
        /* dupa poza din configurator (ixaria-pdp.js), care ramane prima — ori dupa pozele
           raspunsului „lifestyle" (.sl-life), care stau inaintea tuturor */
        var lifes = trk.querySelectorAll(".sl-life");
        var lead = trk.querySelector(".sl-cfgshot") || lifes[lifes.length - 1];
        trk.insertBefore(previewSlide, lead ? lead.nextSibling : trk.firstChild);
      }
      /* Desenul cu dimensiuni e a patra poza. Poza din configurator nu se
         numara (nici poza raspunsului „lifestyle"): apare in fata doar dupa
         configurator si ar muta desenul pe locul cinci. Cu mai putine poze
         intra ultimul, dar tot inaintea filmului, care ramane la capat. */
      if (dims) {
        var photos = trk.querySelectorAll(".sl:not(.sl-cfgshot):not(.sl-life)");
        trk.insertBefore(
          makeSlide(dims, "dims"),
          photos[3] || trk.querySelector(".sl-ix.sl-video") || null,
        );
      }
      /* Poza de pe ecran ramane pe locul ei din lista, iar cele noi se aseaza
         in jurul ei — asa ramane si poza mare din grila de pe tableta, care e
         mereu primul slide. Exceptie: randarea frontala. Cat clientul e inca pe
         primul slide (n-a mutat caruselul), ea ia primul loc si se vede. */
      if (keepSrc && keepAt >= 0 && !(front && keepAt === 0)) {
        var kept = null;
        Array.prototype.some.call(trk.children, function (sl) {
          var im = sl.querySelector("img");
          if (im && im.getAttribute("src") === keepSrc) { kept = sl; return true; }
          return false;
        });
        if (kept && trk.children[keepAt] !== kept) {
          trk.insertBefore(kept, trk.children[keepAt] || null);
        }
      }
      if (typeof window.heroSync === "function") window.heroSync();
    }

    if (jumpToIt && typeof window.heroTo === "function") {
      /* Sare la poza canapelei in culoarea aleasa, nu la textura de la capat
         si nici la desenul cu dimensiuni. */
      var first = trk.querySelector(
        ".sl-ix:not([data-ix='texture']):not([data-ix='video']):not([data-ix='dims'])",
      );
      var idx = first ? Array.prototype.indexOf.call(trk.children, first) : 0;
      window.heroTo(idx);
    }
  }

  /* ── Filmul „descopera" ─────────────────────────────────────────────
     Cand aplicatia tine cate un film pe forma, sectiunea video urmeaza forma
     aleasa. Adresa se ia din blocul deja randat de Liquid pentru forma
     respectiva, ca sa nu existe o a doua lista de filme care sa iasa din
     sincron. Fara film pentru forma curenta ramane cel randat initial. */
  /* Spune o singura data de unde vine filmul si ce are produsul, ca sa nu
     ramana de ghicit cand sectiunea arata altceva decat se astepta. */
  function reportVideoSource() {
    var v = (window.IX_PDP && window.IX_PDP.video) || {};
    if (!v.source) return;
    var el = document.querySelector("#ix-pdp #vidsec video");
    var src = (el && el.currentSrc) || (el && el.getAttribute("src")) || v.src || "(fara src)";
    console.info(
      "[ixaria] film sectiune — sursa: " +
        v.source +
        " | src: " +
        src +
        " | produsul are " +
        (v.shopifyVideos || 0) +
        " film(e) Shopify si " +
        (v.externalVideos || 0) +
        " extern(e)",
    );
    /* Un <video> care nu poate incarca fisierul esueaza in tacere: ramane
       dreptunghiul negru. Codul erorii spune daca adresa lipseste, da 404 sau
       formatul nu e suportat. */
    if (!el) return;
    el.addEventListener(
      "error",
      function () {
        var e = el.error;
        console.warn(
          "[ixaria] filmul nu s-a putut incarca — " +
            (e ? "cod " + e.code + (e.message ? ": " + e.message : "") : "eroare necunoscuta") +
            " | src: " +
            (el.currentSrc || el.getAttribute("src") || "(gol)"),
        );
      },
      { once: true },
    );
    if (!el.getAttribute("src")) {
      console.warn("[ixaria] sectiunea video nu are niciun film configurat");
    }
    /* Ce are produsul, ca sa se vada dintr-o privire daca filmul e pe produs,
       in Content → Files sau nicaieri. */
    var media = v.media || [];
    console.info(
      "[ixaria] product.media — " +
        (media.length
          ? media
              .map(function (m) {
                return (
                  m.type +
                  (m.sources
                    ? " [" +
                      m.sources
                        .map(function (x) {
                          return x.format + " " + x.width + "px";
                        })
                        .join(", ") +
                      "]"
                    : "")
                );
              })
              .join(" | ")
          : "(gol)"),
    );
    if (v.media) window.__ixMedia = v.media;
  }

  function syncSectionVideo() {
    var host = document.getElementById("ix-gi-shapes");
    if (!host) return;
    var target = document.querySelector("#ix-pdp #vidsec video");
    if (!target) return;
    var block = host.querySelector(".ix-gi-shape:not([hidden]) video");
    var url = block && block.getAttribute("src");
    if (!url || target.getAttribute("src") === url) return;
    target.setAttribute("src", url);
    /* si slide-ul video din galerie, care foloseste acelasi fisier */
    refreshPreview(false);
    /* Sursa schimbata cere load() inainte de play, altfel ramane cadrul vechi. */
    try {
      target.load();
      var playing = target.play();
      if (playing && typeof playing.catch === "function") playing.catch(function () {});
    } catch (e) {}
  }

  /* ── Randul de beneficii ────────────────────────────────────────────
     Randurile vin din metafield-ul custom.beneficii_cta al produsului (sau
     cele trei de rezerva), fiecare cu textul lui ca sablon in data-tpl
     (snippets/ixaria-benefit-row.liquid). Tokenii din sablon se completeaza
     aici, nu doar in Liquid: forma aleasa se schimba in pagina, iar o data
     scrisa in pagina ramane in cache („Transport Gratuit ≈ 1-12 oct." si in
     noiembrie).

       [[sleeping_area]]    suprafata de dormit a formei alese (shapes.byId[].
                            sleepingArea) — se schimba odata cu forma, iar
                            randul dispare la formele care nu se extind
       [[production_time]]  termenele din setarile sectiunii, in saptamani
       [[delivery_dates]]   productie + transport, ca interval de date de la
                            ziua curenta

     Formatul datei urmeaza aplicatia Ixaria: luna se scrie o singura data cand
     intervalul nu o depaseste. */
  var RO_MONTHS = ["ian.","feb.","mar.","apr.","mai","iun.","iul.","aug.","sep.","oct.","nov.","dec."];

  function orderTiming() {
    var o = (window.IX_PDP && window.IX_PDP.order) || {};
    var n = function (v, fallback) {
      return typeof v === "number" && isFinite(v) && v >= 0 ? v : fallback;
    };
    return {
      prodMin: n(o.productionMinDays, 7),
      prodMax: n(o.productionMaxDays, 14),
      shipMin: n(o.shippingMinDays, 2),
      shipMax: n(o.shippingMaxDays, 4),
    };
  }

  function addDays(days) {
    var d = new Date();
    d.setDate(d.getDate() + days);
    return d;
  }

  function formatDateRange(fromDays, toDays) {
    var a = addDays(fromDays),
      b = addDays(toDays);
    var ma = RO_MONTHS[a.getMonth()],
      mb = RO_MONTHS[b.getMonth()];
    if (a.getDate() === b.getDate() && ma === mb) return a.getDate() + " " + ma;
    if (ma === mb) return a.getDate() + "-" + b.getDate() + " " + mb;
    return a.getDate() + " " + ma + " - " + b.getDate() + " " + mb;
  }

  function weeksLabel(minDays, maxDays) {
    var lo = Math.max(1, Math.ceil(minDays / 7));
    var hi = Math.max(lo, Math.ceil(maxDays / 7));
    var n = lo === hi ? String(lo) : lo + "-" + hi;
    /* 1 săptămână / 2 săptămâni / 20 de săptămâni */
    var word = hi === 1 ? "săptămână" : hi < 20 ? "săptămâni" : "de săptămâni";
    return n + " " + word;
  }

  function sleepingAreaFor(shapeName) {
    var shape = shapeData(shapeName);
    var sl = shape && shape.sleepingArea;
    if (!sl || !sl.width || !sl.depth) return null;
    return Math.round(sl.width) + " × " + Math.round(sl.depth) + " cm";
  }

  /* Valorile tokenilor. null = nu exista pentru forma aleasa (randul pleaca);
     undefined = nu se stie aici, deci randul ramane cum l-a randat Liquid —
     suprafata de dormit, pe un produs fara forme in aplicatie, nu dispare. */
  function benefitTokens() {
    var t = orderTiming();
    return {
      sleeping_area: DATA.shapes && DATA.shapes.byId ? sleepingAreaFor(currentShapeName()) : undefined,
      production_time: weeksLabel(t.prodMin, t.prodMax),
      delivery_dates: formatDateRange(t.prodMin + t.shipMin, t.prodMax + t.shipMax),
    };
  }

  function renderBenefits() {
    var tokens = benefitTokens();
    document.querySelectorAll("#pbenefits .pb-row[data-tpl]").forEach(function (row) {
      var span = row.querySelector("span");
      if (!span) return;
      var unknown = false,
        missing = false;
      var text = row
        .getAttribute("data-tpl")
        .replace(/\[\[\s*([a-z_]+)\s*\]\]/g, function (m, key) {
          /* un token pe care tema nu il stie ramane scris cum e */
          if (!Object.prototype.hasOwnProperty.call(tokens, key)) return m;
          var v = tokens[key];
          if (v === undefined) unknown = true;
          else if (!v) missing = true;
          return v || "";
        });
      if (unknown) return;
      if (missing) {
        row.hidden = true;
        return;
      }
      row.hidden = false;
      span.textContent = text.replace(/\s+/g, " ").trim();
    });
  }

  /* ── Adoption ───────────────────────────────────────────────────────
     The port owns selection; this only follows it. Both hooks call through to
     the original so the page's own behaviour — the label, closing the sheet,
     the swatch name in three places — is untouched. */
  function adopt() {
    /* Wrapping pickShape/pickSwatch twice would run the port's own handler
       twice per click, so adopt at most once however often this is loaded. */
    if (window.__ixariaPdpDataAdopted) return;
    window.__ixariaPdpDataAdopted = true;

    var hasShapes = renderShapes();
    if (!hasShapes && typeof window.ixTypeselFallback === "function") window.ixTypeselFallback();

    var originalPickShape = window.pickShape;
    if (typeof originalPickShape === "function") {
      window.pickShape = function (el) {
        originalPickShape.apply(this, arguments);
        /* The port writes the tile's data-dim into the summary; a shape with no
           footprint configured would blank it, so restore what was there. */
        var dimEl = document.querySelector("#typesel .t-d");
        if (dimEl && !el.getAttribute("data-dim")) dimEl.textContent = "";
        refreshPreview(true);
        /* alta forma: randarile ei, nu ale celei de dinainte */
        warmFronts();
        showGeneralInfoFor(el.getAttribute("data-name"));
        renderBenefits();
        syncSectionVideo();
        syncShortDescription();
        applyVicDescriptionToSheet();
      };
    }

    var originalPickSwatch = window.pickSwatch;
    if (typeof originalPickSwatch === "function") {
      window.pickSwatch = function (el) {
        originalPickSwatch.apply(this, arguments);
        /* The app's photos of this exact combination follow the product media. */
        refreshPreview(!autoPick);
        /* culoarea noua pe celelalte forme, ca o schimbare de forma sa nu astepte poza */
        /* (inainte de load nu: atunci le cere warmFronts, dupa poza de sus) */
        if (typeof window.ixWarmOtherShapes === "function" && document.readyState === "complete") {
          if (window.requestIdleCallback) window.requestIdleCallback(window.ixWarmOtherShapes, { timeout: 1500 });
          else setTimeout(window.ixWarmOtherShapes, 500);
        }
      };
    }

    refreshPreview(false);
    showGeneralInfoFor(currentShapeName());
    renderBenefits();
    reportVideoSource();
    syncSectionVideo();

    loadSnapshot();

    var haveCombo = !!(DATA.comboPreviews && DATA.comboPreviews.byShapeId);
    var haveGallery = !!(DATA.shapeGallery && DATA.shapeGallery.byShapeId);
    console.info(
      "[ixaria] PDP imagery — shapes: " +
        (hasShapes ? hasShapes.length + " from the app" : "not configured, markup kept") +
        ", combination previews: " +
        (haveCombo ? "available" : "none published") +
        ", shape gallery: " +
        (haveGallery ? "available" : "none published"),
    );
  }

  /* ── Curatare si intretinere, dupa materialul ales ──────────────────
     Textul e pe categoria materialului (Practic, Confort, Premium, Lux,
     Special), scris in aplicatia Ixaria. Categoriile stau in metafield-urile
     aplicatiei, pe care doar blocul ei le poate pune in pagina; blocul sta
     singur in templates/product.ixaria-app-data.json, de unde se citeste aici
     #ixaria-config. Sunt aceleasi pe tot magazinul, deci se cer o data pe
     sesiune.

     Culoare -> tipul de material care o contine (materials.byId[gid].colorIds)
     -> materialCategoryId -> textul categoriei. Inaintea lui trece textul scris
     pe produs pentru categoria aceea (tab_cleaning_maintenance.materialTexts);
     fara nici unul ramane ce a randat sectiunea. */
  /* v2: si subtitle / description, pentru caseta de la „Alege materialul" */
  var CATEGORIES_KEY = "ixaria:materialCategories:v2";
  var categories = null;
  var categoriesLoading = null;
  var cleaningDefault = null;

  function loadMaterialCategories() {
    if (categories) return Promise.resolve(categories);
    try {
      var cached = JSON.parse(sessionStorage.getItem(CATEGORIES_KEY) || "null");
      if (cached && cached.length) return Promise.resolve((categories = cached));
    } catch (e) {}
    if (categoriesLoading) return categoriesLoading;
    var handle = window.IX_PDP && window.IX_PDP.product && window.IX_PDP.product.handle;
    if (!handle || typeof fetch !== "function") return Promise.resolve(null);
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    categoriesLoading = fetch(root + "products/" + encodeURIComponent(handle) + "?view=ixaria-app-data", {
      credentials: "same-origin",
    })
      .then(function (r) {
        return r.ok ? r.text() : "";
      })
      .then(function (html) {
        var m = /<script[^>]*id="ixaria-config"[^>]*>([\s\S]*?)<\/script>/.exec(html);
        var cfg = m ? JSON.parse(m[1]) : null;
        categories = ((cfg && cfg.materialCategories) || []).map(function (c) {
          return {
            id: c.ixariaPriceCategoryId,
            key: c.id,
            name: c.name,
            html: c.cleaningRichText || "",
            subtitle: c.subtitle || "",
            description: c.description || "",
          };
        });
        if (categories.length) {
          try {
            sessionStorage.setItem(CATEGORIES_KEY, JSON.stringify(categories));
          } catch (e) {}
        }
        return categories;
      })
      .catch(function () {
        categories = [];
        return categories;
      });
    return categoriesLoading;
  }

  /* Placa aleasa; cea multicolora are toate culorile ei in data-colors. */
  function selectedColorNames() {
    var sw = document.querySelector("#pdp .sw.on");
    if (!sw) return [];
    try {
      var list = JSON.parse(sw.dataset.colors || "[]");
      if (list.length) return list;
    } catch (e) {}
    return sw.dataset.name ? [sw.dataset.name] : [];
  }

  function categoryFor(id) {
    for (var i = 0; categories && i < categories.length; i++) {
      if (categories[i].id === id) return categories[i];
    }
    return null;
  }

  /* Categoriile culorilor alese, fara dubluri, in ordinea zonelor. Pana vin
     culorile din snapshot, numele se leaga de categorie ca la pret
     (ixCurrentTier din ixaria-pdp.js: „Luna 08" -> Luna -> Practic). */
  function selectedCategories() {
    var byId = (DATA.materials && DATA.materials.byId) || {};
    var out = [],
      seen = {};
    selectedColorNames().forEach(function (name) {
      var colorId = colorIdFor(name);
      var gid = colorId && materialGidFor(colorId);
      var id = gid && byId[gid] && byId[gid].materialCategoryId;
      if (id && !seen[id]) {
        seen[id] = true;
        out.push({ id: id, gid: gid, cat: categoryFor(id) });
      }
    });
    if (!out.length && categories && typeof window.ixCurrentTier === "function") {
      var tier = String(window.ixCurrentTier() || "").toLowerCase();
      for (var i = 0; tier && i < categories.length; i++) {
        if (String(categories[i].name).toLowerCase() === tier) {
          out.push({ id: categories[i].id, gid: null, cat: categories[i] });
          break;
        }
      }
    }
    return out;
  }

  /* materialTexts nu are inca nicio intrare publicata, deci cheia se cauta pe
     toate id-urile pe care le are categoria. */
  function productTextFor(pick) {
    var own = (DATA.cleaning && DATA.cleaning.materialTexts) || {};
    var hit = own[pick.id] || (pick.gid && own[pick.gid]) || (pick.cat && own[pick.cat.key]);
    if (hit && typeof hit === "object") hit = hit.richText;
    return typeof hit === "string" && hit.trim() ? hit : "";
  }

  /* Doar textul, fara etichete: un bloc cu <p></p> sau &nbsp; nu e text. */
  function plainText(html) {
    return String(html || "")
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;|\u00a0/g, " ")
      .trim();
  }

  function syncCleaningInfo() {
    var box = document.getElementById("info-curatare-text");
    if (!box) return;
    if (cleaningDefault === null) cleaningDefault = box.innerHTML;
    var parts = selectedCategories()
      .map(function (pick) {
        var html = productTextFor(pick) || (pick.cat && pick.cat.html) || "";
        return html ? { name: pick.cat ? pick.cat.name : "", html: html } : null;
      })
      .filter(Boolean);
    /* Culoarea aleasa nu are text, si nici produsul sau Customize: raman
       textele tuturor categoriilor, ca foaia sa nu se deschida goala. */
    if (!parts.length && !plainText(cleaningDefault) && categories) {
      parts = categories
        .filter(function (c) {
          return plainText(c.html);
        })
        .map(function (c) {
          return { name: c.name, html: c.html };
        });
    }
    if (!parts.length) {
      box.innerHTML = cleaningDefault;
    } else if (parts.length === 1) {
      box.innerHTML = parts[0].html;
    } else {
      /* canapea pe zone, din categorii diferite: cate un text pentru fiecare */
      box.innerHTML = parts
        .map(function (p) {
          return (p.name ? "<h4>" + esc(p.name) + "</h4>" : "") + p.html;
        })
        .join("");
    }
    /* Randul se arata din Liquid pentru orice produs cu materiale
       (ixaria-pdp-info); dupa ce vin categoriile ramane doar daca foaia chiar
       are ceva de aratat. */
    if (categories) {
      var sec = document.getElementById("info-curatare");
      var row = document.querySelector('#deep .drow[data-info="curatare"]');
      if (row) {
        row.hidden = !plainText(box.innerHTML) && !(sec && sec.querySelector(".ix-tab-image, .ix-tab-video"));
      }
    }
  }

  /* Chemata de openInfo (ixaria-pdp.js) inainte sa se deschida panoul; daca
     textele categoriilor nu au sosit inca, panoul se actualizeaza cand vin. */
  window.ixSyncMaterialInfo = function () {
    syncCleaningInfo();
    if (!categories) loadMaterialCategories().then(syncCleaningInfo);
  };

  /* Se cer din timp, dupa ce pagina si-a pus culorile, ca panoul sa se
     deschida direct cu textul materialului si ca randul sa dispara daca nu
     exista niciun text. */
  if (document.getElementById("info-curatare-text") && DATA.materials && DATA.materials.byId) {
    var prefetchCategories = function () {
      var run = function () {
        loadMaterialCategories().then(syncCleaningInfo);
      };
      if (window.requestIdleCallback) window.requestIdleCallback(run, { timeout: 4000 });
      else setTimeout(run, 1500);
    };
    if (window.ixSwatchesReady) prefetchCategories();
    else document.addEventListener("ixaria:swatches-ready", prefetchCategories, { once: true });
  }

  /* ── „Alege materialul" ─────────────────────────────────────────────
     Placile tipurilor de material (#mtsel, ixaria-pdp-buybox.liquid), din optiunea
     de textile a produsului: Practic, Confort, Premium, Lux, Special. Tipul unei
     culori vine din colectia ei (ixTierOf din ixaria-pdp.js: Luna, Manila -> Practic),
     ca la pret si la cos.

     - Click pe un tip: banda de culori se reface doar cu culorile lui (stripForType)
       si se alege prima, cu poze facute — pretul si cosul o urmeaza.
     - Culoarea aleasa altfel (configuratorul, adresa): tipul ei devine cel ales
       (ixSyncMaterialType, chemata de pickSwatch).
     - Sub placi, caseta tipului ales: textul din Theme settings → Tipuri de material,
       altfel descrierea categoriei din aplicatie. */
  function tierKey(t) {
    return String(t || "").trim().toLowerCase();
  }
  function nameTier(name) {
    return typeof window.ixTierOf === "function" ? tierKey(window.ixTierOf(name)) : "";
  }
  /* o placa multicolora are culori dintr-o singura colectie */
  function entryTier(m) {
    var first = m && (m.colors ? m.colors[0] : m);
    return nameTier(first && first.name);
  }
  function materialTiles() {
    return Array.prototype.slice.call(document.querySelectorAll("#mtsel .mt"));
  }

  /* Lista benzii doar cu tipul ales: opts.tier (click pe tip), altfel tipul culorii
     pe care banda o va alege — aceeasi ordine de decizie ca in renderSwatchStrip.
     Cand tipul are sub sase culori cu poze, restul locurilor se iau din celelalte
     culori ale lui din aplicatie (motorul le randeaza doar daca sunt alese).
     null = banda ramane nefiltrata (fara „Alege materialul", sau tip necunoscut). */
  function stripForType(ordered, opts) {
    if (!materialTiles().length) return null;
    var list = ordered.list;
    var tier = tierKey(opts.tier);
    if (!tier) {
      var current = opts.reset ? null : currentColorName();
      var pick =
        (!opts.selectFirst && !opts.reset && !window.ixUrlLive && urlSwatch(list)) ||
        (opts.selectFirst && list[0]) ||
        list.filter(function (m) { return m.name === current; })[0] ||
        list[ordered.recent] ||
        list.filter(function (m) { return !m.colors; })[0] ||
        list[0];
      tier = entryTier(pick);
    }
    if (!tier) return null;
    var inTier = function (m) {
      return entryTier(m) === tier;
    };
    var out = list.filter(inTier);
    var have = {};
    out.forEach(function (m) {
      if (!m.colors) have[colorKey(m.name)] = true;
    });
    Object.keys(appColors).forEach(function (k) {
      if (out.length < MAX_SWATCHES && !have[k] && inTier(appColors[k])) {
        have[k] = true;
        out.push(appColors[k]);
      }
    });
    if (!out.length) return null;
    return { list: out, recent: list.slice(0, ordered.recent).filter(inTier).length };
  }

  /* Tipurile care au culori la produsul asta: din aplicatie, sau din banda de rezerva
     a temei. null cat timp nu se stie (banda inca se incarca). */
  function availableTiers() {
    var out = {},
      any = false;
    var add = function (name) {
      var k = nameTier(name);
      if (k) {
        out[k] = true;
        any = true;
      }
    };
    (lastOffered || []).forEach(function (m) {
      add(m.name);
    });
    Object.keys(appColors).forEach(function (k) {
      add(appColors[k].name);
    });
    if (!lastOffered) {
      document.querySelectorAll("#pdp .sw-strip .sw[data-name]").forEach(function (sw) {
        add(sw.dataset.name);
      });
    }
    return any ? out : null;
  }

  function syncMaterialType() {
    var tiles = materialTiles();
    if (!tiles.length) return;
    var tier = nameTier(currentColorName());
    var avail = availableTiers();
    tiles.forEach(function (t) {
      var k = tierKey(t.dataset.tier);
      if (tier) {
        t.classList.toggle("on", k === tier);
        t.setAttribute("aria-checked", k === tier ? "true" : "false");
      }
      t.disabled = !!avail && !avail[k] && !t.classList.contains("on");
    });
    revealMaterialTile();
    /* Placi din alt tip ramase in banda: o culoare adusa de configurator sau din
       adresa (ixAdoptColour) cand banda nu s-a putut reface din aplicatie. */
    if (tier) {
      document.querySelectorAll("#pdp .sw-strip .sw[data-name]").forEach(function (sw) {
        var k = nameTier(sw.dataset.name);
        sw.classList.toggle("sw-off", !!k && k !== tier);
      });
    }
    renderMaterialCard();
  }
  window.ixSyncMaterialType = syncMaterialType;

  /* Pe telefon placile nu incap toate si randul se trage lateral (ixaria-pdp.css, .mt-row):
     cand se schimba tipul ales, randul aluneca pana cand placa lui ajunge la mijloc (cat se
     poate, la capete browserul opreste derularea). Doar randul: scrollIntoView ar misca si
     pagina. Prima data fara animatie; o culoare noua din acelasi tip nu muta randul. */
  function revealMaterialTile() {
    var on = document.querySelector("#mtsel .mt.on");
    var row = on && on.parentNode;
    if (!row || !row.clientWidth || row._ixOn === on) return;
    var r = row.getBoundingClientRect();
    var b = on.getBoundingClientRect();
    var left = row.scrollLeft + (b.left - r.left) - (row.clientWidth - b.width) / 2;
    row.scrollTo({ left: Math.max(0, left), behavior: row._ixOn ? "smooth" : "auto" });
    row._ixOn = on;
  }

  window.ixPickMaterialType = function (btn) {
    if (!btn || btn.disabled || btn.classList.contains("on")) return;
    var tier = tierKey(btn.dataset.tier);
    if (lastOffered && lastOffered.length) {
      renderSwatchStrip(lastOffered, { tier: tier, userPick: true });
      return;
    }
    /* banda de rezerva a temei (produs fara culori in aplicatie) */
    var hit = Array.prototype.filter.call(document.querySelectorAll("#pdp .sw-strip .sw[data-name]"), function (sw) {
      return nameTier(sw.dataset.name) === tier;
    })[0];
    if (hit && typeof window.pickSwatch === "function") window.pickSwatch(hit);
  };

  /* „Vezi diferențe": fereastra cu toate tipurile din configurator, pe tipul ales. Ea
     sta in configuratorul ascuns (#ix-cfg); html.ix-matd-solo (ixaria-pdp.css) o arata
     singura, pana se inchide. */
  /* Fereastra e a configuratorului, care porneste singur abia cand pagina s-a linistit si doar
     pe o conexiune ieftina (ixaria-cfg-overlay.js). Inainte de asta clicul nu facea nimic
     (cerut 2026-10-19): acum porneste configuratorul pe loc, butonul arata ca lucreaza
     (.is-wait) si fereastra se deschide cand e gata (cel mult ~20s). */
  var diffWait = 0;
  window.ixOpenMaterialDiff = function () {
    var modal = document.getElementById("material-detail-modal");
    if (!modal) return;
    if (typeof window.openMaterialDetail !== "function") {
      if (diffWait) return;
      var btn = document.querySelector("#mtsel .mt-diff");
      var busy = function (on) {
        if (!btn) return;
        btn.classList.toggle("is-wait", on);
        if (on) btn.setAttribute("aria-busy", "true");
        else btn.removeAttribute("aria-busy");
      };
      if (typeof window.ixCfgWarm === "function") window.ixCfgWarm(true);
      busy(true);
      var tries = 0;
      diffWait = setInterval(function () {
        var ready = typeof window.openMaterialDetail === "function";
        if (!ready && ++tries < 200) return;
        clearInterval(diffWait);
        diffWait = 0;
        busy(false);
        if (ready) window.ixOpenMaterialDiff();
      }, 100);
      return;
    }
    var root = document.documentElement;
    if (!root.classList.contains("ix-cfg-open") && !root.classList.contains("ix-matd-solo")) {
      root.classList.add("ix-matd-solo");
      var watch = new MutationObserver(function () {
        if (modal.classList.contains("open")) return;
        root.classList.remove("ix-matd-solo");
        watch.disconnect();
      });
      watch.observe(modal, { attributes: true, attributeFilter: ["class"] });
    }
    var on = document.querySelector("#mtsel .mt.on");
    window.openMaterialDetail(on ? tierKey(on.dataset.tier) : null);
  };

  /* Textul casetei pentru un tip: cel din Theme settings, altfel descrierea categoriei din
     aplicatie (Material categories), intreaga, altfel cea din fereastra configuratorului
     (MATERIAL_DETAIL), cu prima propozitie (pana la primul punct, cu tot cu el) ingrosata.
     "" = inca nu se stie. */
  function materialCardHtml(key) {
    var own = document.querySelector('#mtsel template[data-mt-text="' + key + '"]');
    if (own && plainText(own.innerHTML)) return own.innerHTML;
    var cat = (categories || []).filter(function (c) {
      return tierKey(c.name) === key;
    })[0];
    var body = cat ? String(cat.description || "").replace(/\s+/g, " ").trim() : "";
    if (!body && categories) {
      var md = (window.MATERIAL_DETAIL || []).filter(function (m) {
        return m.key === key;
      })[0];
      body = (md && md.desc) || "";
    }
    var lead = /^.*?\.(?=\s|$)/.exec(body);
    if (!lead) return esc(body);
    var rest = body.slice(lead[0].length);
    return "<strong>" + esc(lead[0]) + "</strong>" + esc(rest);
  }

  function renderMaterialCard() {
    var card = document.getElementById("mt-card");
    var on = document.querySelector("#mtsel .mt.on");
    if (!card || !on) return;
    var key = tierKey(on.dataset.tier);
    var html = materialCardHtml(key);
    if (!html && !categories) {
      /* textele aplicatiei inca nu au venit: caseta ramane schelet pana sosesc */
      loadMaterialCategories().then(renderMaterialCard);
      return;
    }
    var txt = card.querySelector(".mt-card-t");
    var img = card.querySelector(".mt-card-i");
    card.classList.remove("is-loading");
    card.hidden = !html;
    if (txt) txt.innerHTML = html;
    var src = on.dataset.img || "";
    if (img) {
      if (src && img.getAttribute("src") !== src) img.setAttribute("src", src);
      img.hidden = !src;
    }
    card.classList.toggle("has-img", !!src);
  }

  /* Textele categoriilor se cer de la inceput (o data pe sesiune), ca si caseta sa fie
     gata odata cu culorile; apoi tipul culorii deja alese (banda de rezerva). */
  if (document.getElementById("mt-card")) {
    loadMaterialCategories().then(renderMaterialCard);
    if (document.querySelector("#pdp .sw-strip .sw.on[data-name]")) syncMaterialType();
  }

  if (
    !DATA.shapes &&
    !DATA.shapeGallery &&
    !DATA.comboPreviews &&
    !document.getElementById("ix-gi-shapes") &&
    !(window.IX_PDP && window.IX_PDP.figaro && window.IX_PDP.figaro.snapshotUrl) &&
    !document.querySelector("#pbenefits .pb-row[data-tpl]")
  ) {
    return; /* nothing published for this product */
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", adopt);
  } else {
    adopt();
  }
})();
